// import CryptoJS from "crypto-js";

// const SECRET_KEY = process.env.REACT_APP_S_KEY; // Use env variable in production

// export const encrypt = (data) => {
//   return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
// };

// export const decrypt = (encryptedData) => {
//   const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
//   return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
// };

import CryptoJS from "crypto-js";

const SECRET_KEY = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_S_KEY); // 32-byte key
const SECRET_KEY_1 = 'my_secret_key_123'; // Use a secure key
const IV = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV); // 16-byte IV

// Encrypt function
export const encrypt = (data) => {
  const encrypted = CryptoJS.AES.encrypt(data, SECRET_KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7, // Ensure this matches the backend
  });
  return encrypted.toString(); // Default is Base64
};

// Decrypt function
export const decrypt = (encryptedData) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7, // Ensure this matches the backend
  });
  return bytes.toString(CryptoJS.enc.Utf8);
};


export const encryptId = (id) => {
  return CryptoJS.AES.encrypt(id.toString(), SECRET_KEY_1).toString();
};
export const decryptId = (encryptedId) => {
  const bytes = CryptoJS.AES.decrypt(encryptedId, SECRET_KEY_1);
  return bytes.toString(CryptoJS.enc.Utf8);
};